<kgr-page-title title="Passwort wählen" i18n-title></kgr-page-title>

<div
  [kgrLoading]="state() === ComponentStates.loading"
  [kgrLoadingBlocking]="true"
  class="kgr-region kgr-region--secondary kgr-region--bordered"
>
  @if (state() === ComponentStates.missingRequiredOrganizationId) {
    <kgr-errors i18n> Bitte rufe diese Seite über die Webseite deines Vereins auf. </kgr-errors>
  }
  @if (state() === ComponentStates.requestToken) {
    <kgr-password-request-reset (done)="onRequestResetTokenDone()"></kgr-password-request-reset>
  }
  @if (state() === ComponentStates.validateResetToken) {
    <div class="kgr-alert kgr-alert--info" i18n>Wir haben per E-Mail einen Link zum Zurücksetzen des Passworts geschickt.</div>
    <ng-container *kgrIfAppId="'club_offering'">
      <kgr-validate-password-reset-token
        (validatedPasswordResetToken)="onValidatedPasswordResetToken($event)"
      ></kgr-validate-password-reset-token>
    </ng-container>
  }
  @if (state() === ComponentStates.resetPassword) {
    <div class="kgr-alert kgr-alert--info" i18n>Bitte wähle ein neues Passwort.</div>
    <kgr-password-reset
      [token]="passwordResetToken()"
      (passwordResetSuccessLoginToken)="onPasswordResetSuccessLoginToken($event)"
    ></kgr-password-reset>
  }
  @if (state() === ComponentStates.login) {
    <div class="kgr-alert kgr-alert--info" i18n>Bitte logge dich mit deinem neuen Passwort ein.</div>
    <kgr-login-form [organizationId]="organizationId()" [redirectCommands]="redirectCommands"></kgr-login-form>
  }
</div>
